class PdCartModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.prevVariantIds = [];

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelectorAll('button[type="button"]').forEach(ele => ele.addEventListener(
      'click',
      this.close.bind(this)
    ));
    this.show.bind(this)
    this.open.bind(this)
    this.close.bind(this)
    this.toggleLoading.bind(this)

    this.summaryToggle.setAttribute('role', 'button');

    document.addEventListener('recommendations::loaded', e => {
      if (e.detail.isCartDrawer) {
        if (!document.querySelector('pd-cart-modal product-recommendations')?.innerHTML.trim()) {
          document.querySelector('pd-cart-modal [data-section-type="ss-recommendations"]')?.classList.remove('d-none');
        }
      }
    })
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    this.detailsContainer.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  markRegistryCart() {
    document.body.setAttribute('registry-cart', 'true');
  }

  unmarkRegistryCart() {
    document.body.removeAttribute('registry-cart');
  }

  show(event) {
    const self = this;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.querySelector('html').classList.add('overflow-hidden');
  }

  toggleLoading(open) {
    if(open) {
      this.detailsContainer.querySelector('[data-loading-state]')?.classList?.remove('hidden');
    } else {
      this.detailsContainer.querySelector('[data-loading-state]')?.classList?.add('hidden');
    }
  }

  async open(event, variantIds, productHandle, keepPrevItems) {
    const self = this;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    this.detailsContainer.removeAttribute('close');
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.querySelector('html').classList.add('overflow-hidden');

    const updates = {};
    let hasNoneRegistryItem = false;
    let hasRegistryItem = false;
    const productVariantIdOHand = document.querySelector('product-form .product-variant-id')?.value;
    let productVariantIdsInCart = [];

    // show items in cart
    if (!keepPrevItems) {
      this.toggleLoading(true);
    }
    let resp = await $.get(`/cart?view=items-modal`);
    this.detailsContainer.querySelector('.pd-cart__content').innerHTML = resp;

    // show only the most recently added item
    let recentItemIds = variantIds || [productVariantIdOHand]
    if (keepPrevItems) {
      if (typeof recentItemIds === 'object') {
        this.prevVariantIds = [...this.prevVariantIds, ...recentItemIds];
      } else {
        this.prevVariantIds = [...this.prevVariantIds, recentItemIds];
      }
      recentItemIds = this.prevVariantIds;
    } else {
      this.prevVariantIds = recentItemIds;
    }

    if (recentItemIds) {
      productVariantIdsInCart = [...document.querySelectorAll('[data-productvariantid]')].map(ele => ele.getAttribute("data-productvariantid"));
      for (let ele of [...document.querySelectorAll('[data-productvariantid]')]) {
        const cartProductVariantId = ele.getAttribute("data-productvariantid");
        const isRegistryItem = ele.dataset.isRegistryItem;
        let isBundleItem = false;
        if (typeof recentItemIds !== 'object' && !document.querySelector(`[data-productvariantid="${recentItemIds}"]`)) {
          isBundleItem = ele.dataset.isBundleItem;
        }
        if (!recentItemIds.includes(cartProductVariantId)) {
          if (!isRegistryItem) {
            hasNoneRegistryItem = true;
            updates[cartProductVariantId] = 0;
          }
          if (!isBundleItem) {
            ele.remove();
          }
        } else {
          if (isRegistryItem) {
            hasRegistryItem = true;
            self.markRegistryCart();
          }
          for (let td of [...ele.querySelectorAll('td')]) {
            td.style.borderColor = "transparent";
          }
        }
      }

      // remove duplicate text panels if any
      // this happens when the same variantId is treated as 2 line items
      for (let ele of [...document.querySelectorAll(`.pd-text-panel-free-gift[data-productvariantid="${productVariantIdOHand}"]`)].slice(1)) {
        ele.remove();
      }
    }

    this.toggleLoading(false);
    self.loadRecommendation(productHandle);

    if (hasRegistryItem && hasNoneRegistryItem) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
    }

    // display notification message based on gwp data
    resp = await $.get(`/cart`)
    const data = $(resp).find('#pd-cart__api-gwp').html();
    try {
      const gwpArr = JSON.parse(data.replaceAll(' ', '').replaceAll('\n', ''));

      for (let gwpObj of gwpArr) {
        const variantIds = gwpObj.giftVariantId.split(',').filter(x => x);

        if (gwpObj.shouldAddGiftToCart && variantIds.length == 1) {
          const addingVariantId = variantIds[0];
          jQuery.post('/cart/add.js', {
            quantity: 1,
            id: addingVariantId,
            properties: {
              _GWP: gwpObj.campaignLabel
            }
          }, (e) => {
            console.log('automatically add gift ', 'ok');
          });

          // display gwp message if adding free gift
          document.querySelector(`.pd-text-panel-free-gift[data-productvariantid="${productVariantIdOHand}"]`)?.classList?.remove('hidden');
        }

        // display gwp message if free gift is already added
        if (variantIds.some(x => productVariantIdsInCart.includes(x))) {
          document.querySelector(`.pd-text-panel-free-gift[data-productvariantid="${productVariantIdOHand}"]`)?.classList?.remove('hidden');
        }
      }
    } catch (error) {
      console.log('automatically add gift ', error);
    }
  }

  loadRecommendation(productHandle) {
    if (!productHandle) return;
    const ELM_recommendationSections = this.querySelectorAll('[cart-recommendation-section]');

    ELM_recommendationSections?.forEach(ELM_recommendationSection => {
      const { recType, title, ssProfileId } = ELM_recommendationSection.dataset || {};
      const url = `/products/${productHandle}?view=recommendation-carousel&ss_profile_id=${ssProfileId}`;
      ELM_recommendationSection.classList.add('loading');
      fetch(url)
        .then(res => res.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          let HTML_content = '';
          const ELM_complementary = html.querySelector('#shopify-section-pd-complementary-section');
          const ELM_ssRecommendations = html.querySelector('#shopify-section-ss-recommendation');
          const ELM_sectionTitle = html.querySelector('[pd-upsell-section-title]');
          const sectionTitle = ELM_sectionTitle?.innerHTML || title;

          if (ELM_complementary && ELM_complementary.innerHTML) {
            HTML_content = ELM_complementary.innerHTML;
          }

          if (ELM_ssRecommendations) {
            HTML_content += ELM_ssRecommendations.innerHTML;
          }

          if (HTML_content) {
            ELM_recommendationSection.style.display = '';
            ELM_recommendationSection.querySelector('[cart-recommendation-section-content]').innerHTML = `<h3 class="cart-drawer-recommendations__title">${ sectionTitle }</h3>` + HTML_content;
            ELM_recommendationSection.querySelector('[data-section-type="ss-recommendations"]')?.classList.add('d-none');
          } else {
            ELM_recommendationSection.querySelector('[cart-recommendation-section-content]').innerHTML = '';
            ELM_recommendationSection.style.display = 'none';
          }
          ELM_recommendationSection.classList.remove('loading');
        })
    })
  }

  close(focusToggle = true) {
    this.detailsContainer.removeAttribute('open');
    this.detailsContainer.setAttribute('close', true);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.querySelector('html').classList.remove('overflow-hidden');
  }
}

customElements.define('pd-cart-modal', PdCartModal);
